(ns frontend.view.onboarding.initialize-account.db
  (:require [frontend.db :as db]
            [reagent.core :as r]))

(defonce state (r/cursor db/app-state [:views :onboarding]))
(defonce session (r/cursor db/app-state [:session]))
(defonce account (r/cursor db/app-state [:session :account]))
(defonce tenant (r/cursor db/app-state [:session :tenant]))
